/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { coral, grey, grey75, pink25, navy } from '@zocdoc/branding/colors';

import { breakpoint } from '../../grid';
import { FontFamily } from '../../typography';

export default class SearchDropdownDoctor extends React.PureComponent {
    static propTypes = {
        city: PropTypes.string,
        dataIndex: PropTypes.number,
        dataTest: PropTypes.string,
        highlight: PropTypes.string,
        id: PropTypes.string.isRequired,
        name: PropTypes.string,
        onClick: PropTypes.func,
        onMouseMove: PropTypes.func,
        photoUrl: PropTypes.string.isRequired,
        selected: PropTypes.bool,
        specialty: PropTypes.string.isRequired,
        state: PropTypes.string,
        title: PropTypes.string,
    };

    renderPhoto() {
        const {
            useElasticGrouping,
            photoUrl,
        } = this.props;

        return (
            <Photo responsive={useElasticGrouping}>
                <img
                    alt={photoUrl}
                    src={photoUrl}
                />
            </Photo>
        );
    }

    renderInfo() {
        const {
            city,
            highlight,
            name,
            specialty,
            state,
            title,
            useElasticGrouping,
        } = this.props;

        const docName = highlight || name; // use name if highlight is empty string
        const docNameTitle = title ? `${docName}, ${title}` : docName;

        const specialtyLocation =
            state && city
                ? `${specialty} · ${city}, ${state}`
                : specialty;

        return (
            <Container responsive={useElasticGrouping}>
                <Text
                    dangerouslySetInnerHTML={{ __html: docNameTitle }}
                    responsive={useElasticGrouping}
                />
                <Details responsive={useElasticGrouping}>{specialtyLocation}</Details>
            </Container>
        );
    }

    render() {
        const {
            dataIndex,
            dataTest,
            onClick,
            onMouseMove,
            selected,
            useElasticGrouping,
        } = this.props;

        return (
            <DropdownRow
                active={selected}
                data-index={dataIndex}
                data-test={dataTest}
                onClick={onClick}
                onMouseMove={onMouseMove}
                responsive={useElasticGrouping}
            >
                {this.renderPhoto()}
                {this.renderInfo()}
            </DropdownRow>
        );
    }
}

const DropdownRow = styled.div`
    background: ${p => p.active ? pink25 : 'none'};
    cursor: pointer;
    padding: ${p => p.responsive ? '4px 17px' : '9px 10px'};

    em {
        color: ${p => p.responsive ? coral : 'inherit'};
        font-weight: ${p => p.responsive ? 'normal' : 'bold'};
        font-style: normal;
    }

    ${breakpoint.small} {
        padding: ${p => p.responsive ? '4px 25px' : '9px 10px'};
    }
`;

const Container = styled.div`
    padding-left: 54px;
    padding-top: ${p => p.responsive ? 4 : 0}px;
`;

const Text = styled.div`
    color: ${navy};
    font-family: ${p => p.responsive ? FontFamily.SharpSansMedium : FontFamily.KievitSlabBook};
    font-size: ${p => p.responsive ? 15 : 16}px;
    line-height: 20px;
    padding: ${p => p.responsive ? 0 : 2}px 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-size-adjust: none;
`;

const Photo = styled.div`
    border-color: white;
    border-radius: 50%;
    height: 40px;
    margin-top: ${p => p.responsive ? 1 : 2}px;
    overflow: hidden;
    position: absolute;

    img {
        width: 40px;
    }
`;

const Details = styled.div`
    color: ${p => p.responsive ? grey75 : grey};
    font: 14px/20px ${FontFamily.KievitSlabBook};
    font-family: ${FontFamily.KievitSlabBook};
    font-size: ${p => p.responsive ? 12 : 14}px;
    line-height: ${p => p.responsive ? 14 : 20}px;
    overflow: hidden;
    padding: 2px 0;
    text-overflow: ellipsis;
    text-size-adjust: none;
    white-space: nowrap;
`;
